import { ContextStore } from 'bernie-plugin-mobx';
import { createContext, useContext } from 'react';

export const PlatformContext = createContext({} as ContextStore);

export function usePlatformContext() {
  return useContext(PlatformContext);
}
